import { useQuery } from "@tanstack/react-query";
import WarehouseService from "../services/Warehouses/WarehouseService";

const useWarehouseReceivingZone = (warehouseId) => {
  return useQuery({
    queryKey: [warehouseId, "receivingZones"],
    queryFn: async () => await WarehouseService.getReceivingZonesByWarehouseId(warehouseId),
    enabled: !!warehouseId,
  });
};

export default useWarehouseReceivingZone;